import { useAuthContext } from "providers/Auth";
import { Layout } from "providers/Layout";
import { ApplicationsTableView } from "shared/app/ApplicationsTableView";
import { Redirect } from "shared/components/Redirect";

export const ApplicationsView = () => {
  const { type } = useAuthContext();

  if (!type.isBoomScreen) return <Redirect href="/" />;

  return (
    <Layout>
      <h1 className="text-2xl font-bold">Applications</h1>
      <div className="mt-6">
        <ApplicationsTableView persistParams />
      </div>
    </Layout>
  );
};
